import type { CSSProperties, ReactNode } from 'react'

// The dashboard's card, from the BUILD design: a white panel on the sheet with
// a hairline border and a large radius, whose heading row pairs the title with
// a small mono annotation ("2 configured", "newest first").

const Root = ({
  children,
  style,
}: {
  children: ReactNode
  style?: CSSProperties
}) => (
  <section
    style={{
      background: 'var(--curri-surface)',
      border: '1px solid var(--curri-border)',
      borderRadius: 'var(--curri-radius-lg)',
      padding: '22px 24px 20px',
      ...style,
    }}
  >
    {children}
  </section>
)

const Title = ({ children, meta }: { children: ReactNode; meta?: string }) => (
  <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
    <h2 style={{ fontSize: 16, fontWeight: 600 }}>{children}</h2>
    {meta !== undefined && (
      <span
        style={{
          fontFamily: 'var(--curri-font-mono)',
          fontSize: 11,
          color: 'var(--curri-text-tertiary)',
        }}
      >
        {meta}
      </span>
    )}
  </div>
)

const Description = ({ children }: { children: ReactNode }) => (
  <p
    style={{
      margin: '7px 0 0',
      fontSize: 13.5,
      lineHeight: 1.55,
      color: 'var(--curri-text-tertiary)',
      maxWidth: '74ch',
      textWrap: 'pretty',
    }}
  >
    {children}
  </p>
)

export const Panel = Object.assign(Root, { Title, Description })

/* A hairline one step lighter than the card border, for row separators inside
 * a panel — the design draws these in a lighter grey than the card outline,
 * and no semantic border token sits between the two. */
export const PANEL_HAIRLINE =
  'color-mix(in oklab, var(--curri-border) 55%, transparent)'
